import _ from 'lodash';

import { EXCLUDED_FROM_DATA_EXTRACTION_CATEGORY_ID } from 'constants/documentCategories';

export const reorder = ({ list, startIndex, endIndex }) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);

  result.splice(endIndex, 0, removed);

  return result;
};

export const reorderDocumentTypesNative = ({
  categories,
  currentCategoryId,
  nextCategoryId,
  startIndex,
  endIndex,
  anotherCategoryWithCurrentDocumentType,
}) => {
  const isNextCategoryExcluded = nextCategoryId === EXCLUDED_FROM_DATA_EXTRACTION_CATEGORY_ID;
  const isCurrentCategoryExcluded = currentCategoryId === EXCLUDED_FROM_DATA_EXTRACTION_CATEGORY_ID;

  const current = _.find(categories, { documentCategoryId: currentCategoryId });
  const next = _.find(categories, { documentCategoryId: nextCategoryId });

  const target = current.documentTypeIds[startIndex];
  const anotherCategoryWithTargetId = anotherCategoryWithCurrentDocumentType?.documentCategoryId;

  if (!isNextCategoryExcluded) {
    current.documentTypeIds.splice(startIndex, 1);
  }

  if (isCurrentCategoryExcluded && anotherCategoryWithCurrentDocumentType) {
    _.remove(anotherCategoryWithCurrentDocumentType.documentTypeIds, id => id === target);
  }

  next?.documentTypeIds.splice(endIndex, 0, target);

  return categories?.map(list => {
    switch (list.documentCategoryId) {
      case currentCategoryId:
        return current;

      case nextCategoryId:
        return next;

      case anotherCategoryWithTargetId:
        return anotherCategoryWithCurrentDocumentType;

      default:
        return list;
    }
  });
};

export const putListOrderNumbers = list =>
  list.map((item, index) => ({ ...item, orderNumber: index + 1 }));
